module.exports = __webpack_public_path__ + "static/img/erwei.ab659f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/erwei.jpg
// module id = 4uoZ
// module chunks = 18